<template>
	<div id="page">

		<!-- 页头 -->
		<pagehead />

		<!-- 内容 -->
		<el-container class="api mt35 mauto mb40 w1k2 bw bs">
			<el-main>
				<el-tabs v-model="tag" @tab-click="handleClick">
					
					<!-- 模糊查询 -->
					<el-tab-pane label="模糊查询" name="0">
						<template>
							<!-- 内容 -->
							<div class="apiContent df">
								<!-- 左侧菜单 -->
								<div class="apiContentL">
									<ul>
										<li :class="(index == li) ? 'active' : ''" v-for="(item,index) in leftNav" :key="index" @click="change(index,'pane-0')">{{item}}</li>
									</ul>
								</div>
								<!-- 右侧内容 -->
								<div class="apiContentR" v-html="showTxt"></div>
								
							</div>
						</template>
					</el-tab-pane>
					
					
					<!-- 精确查询 -->
					<el-tab-pane label="精确查询" name="1">
						<template>
							<!-- 内容 -->
							<div class="apiContent df">
								<!-- 左侧菜单 -->
								<div class="apiContentL">
									<ul>
										<li :class="(index == li) ? 'active' : ''" v-for="(item,index) in leftNav" :key="index" @click="change(index,'pane-1')">{{item}}</li>
									</ul>
								</div>
								<!-- 右侧内容 -->
								<div class="apiContentR" v-html="showTxt"></div>
								
							</div>
						</template>
					</el-tab-pane>
				</el-tabs>
			</el-main>
		</el-container>
		<!-- 页脚 -->
		<pagefoot />

	</div>
</template>
<script>
	// 全局变量
	var that;
	export default {
		// 页面变量
		data() {
			return {
				// 标题下标
				tag: 0,
				
				// 展示内容
				showTxt: '',
				
				// 左侧菜单文字
				leftNav: [
					'API接口','请求参数','返回参数','返回示例'
				],
				// 左侧下标
				li: 0,
			}
		},

		// 实例化后
		created() {
			that = this;
			
			// 获取查询接口
			that.apiTxt();
			
			
		},

		// 方法集
		methods: {
			// 切换搜索
			change(index,name){
				// 赋值下标
				that.li = index;
				
				// 判断是否获取的有东西
				if(document.getElementById(name).getElementsByTagName('h3')[index]){
					// 锚点连接切换 （{ 过渡 }）
					document.getElementById(name).getElementsByTagName('h3')[index].scrollIntoView({behavior:"smooth"});
				}
			},
			
			// 获取查询接口
			apiTxt(e){
				// 请求接口 
				that.request({
					url: '/api/Content/getContentByCode',
					// 上传数据
					data:{
						// 精确查询
						code: e ? e : 'obscureAPI',
					},
					method: 'get',
					// 调用成功
					success(rs){
						// 返回成功
						if(rs.code == 200){
							// 赋值文本
							that.showTxt = rs.data;
						}else{
							//弹窗提示用户
							that.$message.error(rs.msg);
						}
					}
				})
			},
			
			// 点击选项卡
			handleClick(e) {
				
				// 新建空字符串
				var str = '';
				
				if ( e.index == '0' ){
					// 赋值字符串
					str = 'obscureAPI';
				} else {
					// 赋值字符串
					str = 'selectAPI';
				}
				
				// 获取查询接口
				that.apiTxt(str);
			}
		},
	};
</script>
<style>
	/* 内容 */
	.api {
		/* height: 550px; */
	}
	/* 内容 */
	.api .el-main {
		overflow: hidden;
	}
	/* 头部选项卡 */
	.api .el-tabs__nav-wrap.is-top {
		display: flex;
		justify-content: center;
	}
	/* 选项卡块样式 */
	.api .el-tabs__item.is-top {
		box-sizing: content-box;
		padding-bottom: 10px;
		color: #999;
		font-size: 18px;
		font-weight: bold;
	}
	/* 选项卡块选中样式 */
	.api .el-tabs__item.is-top.is-active {
		color: #0060DD;
	}
	
	/* 左侧导航 */
	.apiContentL {
		width: 130px;
		padding: 20px 10px;
		background-color: #E5F0FD;
	}
	/* 左侧导航 列表 */
	.apiContentL ul li {
		margin: 10px 0;
		padding: 15px 0;
		text-align: center;
		color: #333;
		border-radius: 5px;
		transition: .2s;
		user-select: none;
		cursor: pointer;
	}
	/* 左侧导航 列表 鼠标经过 */
	.apiContentL ul li:hover {
		background-color: white;
	}
	/* 左侧导航 列表 选中 */
	.apiContentL ul li.active {
		color: #0060DD;
		background-color: white;
	}
	/* api内容 */
	.apiContentR {
		overflow: auto;
		flex: 1;
		height: 450px;
		padding: 30px 35px 30px 40px;
	}
	
	/* 去除头部边距 */
	.api .el-tabs__header {
		margin: 0;
	}
</style>
